module.exports = __webpack_public_path__ + "static/media/cartPageIcon.b3708ff8.svg";